export class Solutions {
  static readonly insito = 'insito';
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  static readonly insito_sante = 'insito_sante';
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  static readonly insito_habitat = 'insito_habitat';
  static readonly alliance = 'alliance';
  static readonly inviseo = 'inviseo';
  static readonly fiscalite = 'fiscalite';
  static readonly portal = 'portal';
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  static readonly funding_tender = 'funding_tender';
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  static readonly bank_proposal_dashboard = 'bank_proposal_dashboard';
  static readonly observatory = 'observatory';
  static readonly dashboard = 'dashboard';
  static readonly subsidies = 'subsidies';
  static readonly dette = 'dette';
  static readonly prospective = 'prospective';
  static readonly detteEtProspective = 'dette_et_prospective';
  static readonly dotations = 'dotations';
  static readonly apollo = 'apollo';
}
